import getDatasourceByType from './utils/getDatasourceByType';
// import filters from '../filters';

export default function(config) {
    // const selfConfig = (config.extendConfig && config.extendConfig[config.base.field]) || {};
    return new Promise((resolve, reject) => {
        getDatasourceByType({
            type: 'Customer',
            maps: {
                groupName: 'name'
            },
            moreConfig: config
        })
            .then(list => {
                return list;
            })
            .then(list => {
                resolve(list);
            })
            .catch(err => {
                reject(err);
            });
    });
}
